import CanaryTestContent from "~partials/canary-test-page.mdx";
import * as React from 'react';
export default {
  CanaryTestContent,
  React
};